/** @format */

import names from './names.json';

type namesIndex = {
  [key: string]: string | undefined;
};

export const recommendationName = (techName: string): string => {
  return (names as namesIndex)[techName] || '';
};
